import React, { useRef, useEffect, useState } from 'react';
import riskReducer from '../../../store/reducers/riskReducer';
import { connect } from "react-redux";
import { compose } from "redux";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

const dummyData = [
  { action_status: 'Due to 30', count: 40 },
  { action_status: 'Overdue 0-30', count: 30 },
  { action_status: 'Overdue 30-60', count: 20 },
  { action_status: 'Overdue 60', count: 10 },
];

const formattedData = (data) => {
  const total = data.reduce((sum, item) => sum + item.count, 0);

  return data.map((item) => {
    let color;
    switch (item.Asset_type) {
      case 'software':
        color = '#05769D';
        break;
      case 'hardware':
        color = '#F07167';
        break;
      default:
        color = '#8884d8';
    }

    return {
      name: item.Asset_type,
      value: item.count,
      percentage: ((item.count / total) * 100).toFixed(1),
      color,
    };
  });
};

const AssetMetric = ({ height = 250, data  }) => {

  const [actionList, setactionList] = useState([]); 
  const [processedData, setprocessedData] = useState([]); 
  //const processedData = formattedData(data);
  const totalActions = data ? data.reduce((sum, item) => sum + item.count, 0) : [];

  const outerRadius = height / 2.5;
  const innerRadius = outerRadius - 30;

  useEffect(() => {
        if (data) {
            setactionList(data)
            setprocessedData(formattedData(data))
        }
    }, [data]);

  return (
    <div className="w-full relative">
      <div className="absolute top-0 left-0 text-sm font-normal text-gray-800 z-20 ml-2 mt-2">
        {totalActions} Assets
      </div>
      <ResponsiveContainer width="100%" height={height}>
        <PieChart>
          <Pie
            data={processedData}
            cx="50%"
            cy="50%"
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            fill="#8884d8"
            dataKey="value"
            paddingAngle={2}
          >
            {processedData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
            <LabelList dataKey="name" position="outside" fontSize={10} />
          </Pie>
          <Tooltip formatter={(value, name, props) => [`${value}`, name]} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};


const mapStateToProps = (state) => {
  //console.log("Actions", state.dashboard.general_dashboard_data.overdue_actions)
    return {

        //token: state.auth.token,
        //departments: state.department.departments,
        //department_id: state.department.department_id
        data: state.asset.assets_stat_data.data
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(AssetMetric);
